<script setup lang="ts">
/**
 * LocalPhone
 *
 * Renders the region-resolved phone number as a tel: link. Region follows the
 * route by default; pass `region` to pin it (the footer pins "national").
 *
 * The `js-dni-phone` class is an inert hook only; GTM call tracking replaces
 * by exact number match, not by class. Keep renders static per route so a Vue
 * re-render does not revert the GTM-swapped number.
 */
import type { PhoneRegion } from '~/config/localNumbers'

const props = defineProps<{
  /** Pin to an explicit region instead of resolving from the route */
  region?: PhoneRegion
}>()

const { display, tel } = useLocalPhone(props.region)
</script>

<template>
  <a :href="`tel:${tel}`" class="js-dni-phone">
    <slot :display="display">{{ display }}</slot>
  </a>
</template>
